const INDEXED_CREATIVE_FIELD_KEYS = [
  "mediaUrls",
  "imageUrls",
  "videoUrls",
  "logoUrls",
];

export const CAROUSEL_INDEXED_FIELD_KEYS = [
  ...INDEXED_CREATIVE_FIELD_KEYS,
  "headlines",
  "descriptions",
  "destinationUrls",
];

export const APPROVAL_FIELD_NAVIGATE_EVENT = "buzzly:approval-field-navigate";

export const toLegacyFieldDomId = (path = "") => {
  let legacyPath = path;

  for (const fieldKey of INDEXED_CREATIVE_FIELD_KEYS) {
    legacyPath = legacyPath.replace(
      new RegExp(`\\.${fieldKey}\\.\\[(\\d+)\\]`, "g"),
      `.${fieldKey}?.[$1]`
    );
  }

  return legacyPath;
};

export const stripIndexedFieldSuffix = (path = "") =>
  path.replace(/\.\[(\d+)\]$/, "");

export const parseIndexedFieldPath = (path = "") => {
  const match = path.match(/\.([^.[]+)\.\[(\d+)\]$/);

  if (!match) {
    return null;
  }

  return {
    fieldKey: match[1],
    index: Number.parseInt(match[2], 10),
  };
};

export const parseCarouselCardIndex = (path = "") => {
  if (!path) {
    return null;
  }

  const directMatch = parseIndexedFieldPath(path);

  if (
    directMatch &&
    CAROUSEL_INDEXED_FIELD_KEYS.includes(directMatch.fieldKey)
  ) {
    return directMatch.index;
  }

  const textFieldMatch = path.match(
    /\.(headlines|descriptions|destinationUrls)\.\[(\d+)\]\.value$/
  );

  if (textFieldMatch) {
    return Number.parseInt(textFieldMatch[2], 10);
  }

  return null;
};

export const getFieldDomPathCandidates = (path = "") => {
  if (!path) {
    return [];
  }

  const candidates = [path, toLegacyFieldDomId(path)];
  const withoutIndex = stripIndexedFieldSuffix(path);

  if (withoutIndex !== path) {
    candidates.push(withoutIndex, toLegacyFieldDomId(withoutIndex));
  }

  return [...new Set(candidates.filter(Boolean))];
};

export const highlightElementTemporarily = ({
  element,
  durationMs,
  scrollBehavior = "smooth",
}) => {
  if (!element) {
    return;
  }

  element.scrollIntoView({ behavior: scrollBehavior, block: "center" });
  element.classList.add("field-pulse");
  window.setTimeout(() => {
    element.classList.remove("field-pulse");
  }, durationMs);
};

export const dispatchApprovalFieldNavigate = (path) => {
  if (!path || typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(APPROVAL_FIELD_NAVIGATE_EVENT, {
      detail: { path },
    })
  );
};
